import clsx from 'clsx'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Icon } from '../../../components'
import { markRead } from '../../../store/notifications'

import './Notification.scss'

const Notification = ({ notification }) => {
   const history = useHistory()
   const { isDarkTheme } = useSelector(state => state.theme)

   const dispatch = useDispatch()

   React.useEffect(() => {
      dispatch(markRead(notification.id))
   }, [notification, dispatch])

   return (
      <div
         className={clsx('Notification', isDarkTheme && 'Notification--dark')}
      >
         <div className="Notification__top">
            <Icon
               name="chevron-left"
               className="Notification__top-icon"
               onClick={() => history.goBack()}
            />
            {notification.heading}
         </div>
         <p className="Notification__description">{notification.description}</p>
      </div>
   )
}

export default Notification
